<div id="mainComponentContainer">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="submissionsHeadings" :data="submissions" :hasActions="true"
                                :hasNoFilter="false"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @filterSearchClicked="onFilterSearchClicked"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onSubmissionActionClicked">
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label>Participating Sites</label>
                                        <bootstrap-select  :selectOptions="sites" :selectedOption="filter.siteId" :elementId="'siteFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onSiteFilterSelect"></bootstrap-select>
                                    </div>
                                    <div class="col-sm-6 align-self-center">
                                        <label>Campaigns</label>
                                        <bootstrap-select  :selectOptions="campaigns" :selectedOption="filter.campaignId" :elementId="'campaignFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onCampaignFilterSelect"></bootstrap-select>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
    
    <view-submission-modal
            :heading="viewSubmissionModal.heading"
            :modalId="viewSubmissionModal.modalId"
            :showModal="viewSubmissionModal.showModal"
            :campaignSubmission="viewSubmissionModal.submission"
            :submissionIsDrawnWinner="viewSubmissionModal.submissionIsDrawnWinner"
            @okClicked="onViewSubmissionModalClose"></view-submission-modal>

</div>
